import { Field, FieldLabel } from '@solinkcorp/solink-ui';
import { type FC } from 'react';
import type { DatasetExpectedOutput } from 'vd-server/db/aiDatasetSchema';
import { ExpectedOutputs } from '../../components/ExpectedOutputs';
import { useDataset } from '../../DatasetsPage/hooks/useDataset';

export const DatasetExpectedOutputs: FC<{
  datasetId: string | undefined;
  expectedOutputs: Record<string, DatasetExpectedOutput>;
  onChange: (
    updater: (prev: Record<string, DatasetExpectedOutput>) => Record<string, DatasetExpectedOutput>,
  ) => void;
}> = ({ datasetId, expectedOutputs, onChange }) => {
  const { outputSchema = [] } = useDataset(datasetId) ?? {};

  if (outputSchema.length === 0) return null;

  return (
    <Field>
      <FieldLabel>Expected Outputs</FieldLabel>
      <div className="flex flex-col gap-2">
        {outputSchema.map((field) => (
          <div key={field.name} className="flex flex-col gap-0.5">
            <span className="text-foreground-secondary body-md">{field.name}</span>
            <ExpectedOutputs
              field={field}
              expected={expectedOutputs[field.name]}
              onChange={(patch) =>
                onChange((prev) => ({
                  ...prev,
                  [field.name]: { ...prev[field.name], ...patch, fieldName: field.name },
                }))
              }
            />
          </div>
        ))}
      </div>
    </Field>
  );
};
